/** How a coloured figure reads: a delta, or a value that is itself the difference. */
/** `warning` is a difference that is a caution rather than bad (e.g. well above target). */
export type FigureTone = "neutral" | "positive" | "negative" | "warning"

export const deltaTone = (pp: number | null): FigureTone => {
  if (pp == null || pp === 0) return "neutral"
  return pp > 0 ? "positive" : "negative"
}

const COLOURED_TONE_CLASS: Record<Exclude<FigureTone, "neutral">, string> = {
  positive: "text-fg-positive-text",
  negative: "text-fg-negative-text",
  warning: "text-fg-warning-text",
}

/** Text class for a figure's tone; a neutral figure takes `neutralClass`. */
export const figureToneClass = (tone: FigureTone, neutralClass = "text-fg-muted"): string =>
  tone === "neutral" ? neutralClass : COLOURED_TONE_CLASS[tone]
